import { SLUGS, resolveSlug } from "../../shared/howRelayWorks";

/** Slug from a location hash, or null. Case-sensitive; a leading "#" is optional. */
export function slugFromHash(hash: string): string | null {
  const slug = hash.startsWith("#") ? hash.slice(1) : hash;
  const resolved = resolveSlug(slug);
  return SLUGS.includes(resolved) ? resolved : null;
}

/** Write "#slug" (or clear the hash for null) without adding a history entry. */
export function setSlugHash(slug: string | null): void {
  if (slug === null) {
    clearSlugHash();
    return;
  }
  history.replaceState(null, "", "#" + slug);
}

export function clearSlugHash(): void {
  history.replaceState(null, "", location.pathname + location.search);
}
